import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var UserCircle = function UserCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM11.9785 13.9951C9.87305 13.9844 8.24023 12.2227 8.24023 9.8916C8.21875 7.7002 9.88379 5.87402 11.9785 5.87402C14.0732 5.87402 15.7168 7.7002 15.7168 9.8916C15.7168 12.2227 14.084 14.0166 11.9785 13.9951ZM11.9785 21.5146C9.57227 21.5146 7.01562 20.5156 5.39355 18.7754C6.62891 16.9277 9.07812 15.8535 11.9785 15.8535C14.8467 15.8535 17.3174 16.9062 18.5635 18.7754C16.9414 20.5156 14.3848 21.5146 11.9785 21.5146Z"
  })));
};

UserCircle.displayName = 'UserCircle';
export default UserCircle;